import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface NavIcons {
  dashboard: string;
  books: string;
  clubs: string;
  profile: string;
  notifications: string;
  theme: string;
  logo: string;
}

const DEFAULT_NAV_ICONS: NavIcons = {
  dashboard: '🏠',
  books: '📚',
  clubs: '👥',
  profile: '👤',
  notifications: '🔔',
  theme: '🌓',
  logo: '📖',
};

@Injectable({ providedIn: 'root' })
export class UiSettingsService {
  private http = inject(HttpClient);

  readonly navIcons = signal<NavIcons>(DEFAULT_NAV_ICONS);

  load() {
    this.http.get<{ navIcons: NavIcons }>(`${environment.apiUrl}/auth/ui-settings`).subscribe({
      next: (data) => {
        if (data?.navIcons) {
          this.navIcons.set({ ...DEFAULT_NAV_ICONS, ...data.navIcons });
        }
      },
      error: () => {},
    });
  }
}
